export default __webpack_public_path__ + "assets/images/5ed72f7f7ebb756fedba55c31ea52922.svg";